import { render } from "./MessageListComponent.vue?vue&type=template&id=2be1e54c&scoped=true"
import script from "./MessageListComponent.vue?vue&type=script&lang=js"
export * from "./MessageListComponent.vue?vue&type=script&lang=js"

import "./MessageListComponent.vue?vue&type=style&index=0&id=2be1e54c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be1e54c"]])

export default __exports__